import React, { useEffect, useState } from 'react';
import { Button, Container, Grid, Paper, TextField, Typography, Checkbox, FormControlLabel } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import axiosinstance from '../../../../api/axiosinstance';
import securedInstance from '../../../../api/securedInstance';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import WelcomeMenus from '../../WelcomeMenus';

const UpdateHiringPartnerForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useSelector((s) => s.auth);
  const [formData, setFormData] = useState({ name: '', logo_url: '', is_active: 1 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axiosinstance.get(`/api/hiring-partners/${id}`)
      .then((res) => {
        const p = Array.isArray(res.data) ? res.data[0] : res.data;
        if (p) setFormData({ name: p.name || '', logo_url: p.logo_url || '', is_active: p.is_active });
        setLoading(false);
      })
      .catch(() => { toast.error('Failed to load'); setLoading(false); });
  }, [id]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await securedInstance.put(`/api/hiring-partners/${id}`, formData);
      toast.success('Updated');
      navigate('/auth/allHiringPartners');
    } catch {
      toast.error('Update failed');
    }
  };

  if (user?.role_id !== 1) return <><h2>Admin only</h2><WelcomeMenus /></>;
  if (loading) return <p style={{ padding: 40 }}>Loading...</p>;

  return (
    <Container maxWidth="sm" sx={{ display: 'flex', mt: 4 }}>
      <Paper elevation={2} sx={{ padding: '28px', width: '100%' }}>
        <form onSubmit={handleSubmit}>
          <Typography variant="h6" gutterBottom>Edit Hiring Partner</Typography>
          <Button onClick={() => navigate(-1)} sx={{ mb: 2 }}>Back</Button>

          <Grid container spacing={2} sx={{ border: '1px solid rgba(0,0,0,0.125)', padding: '20px' }}>
            <Grid item xs={12}>
              <TextField label="Company Name" name="name" fullWidth required
                value={formData.name} onChange={handleChange} />
            </Grid>
            <Grid item xs={12}>
              <TextField label="Logo URL" name="logo_url" fullWidth
                value={formData.logo_url} onChange={handleChange} />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox checked={Boolean(formData.is_active)}
                    onChange={(e) => setFormData({ ...formData, is_active: e.target.checked ? 1 : 0 })} />
                }
                label="Active"
              />
            </Grid>
            <Grid item xs={12}>
              <Button type="submit" variant="contained" fullWidth style={{ backgroundColor: '#3251A3' }}>
                Save Changes
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>
    </Container>
  );
};

export default UpdateHiringPartnerForm;
